import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { availabilityService, CreateAvailabilityInput, SlotInput } from 'services/availabilityService';

export function useProfessionalAvailability(professionalId: string | null | undefined) {
  return useQuery({
    queryKey: ['availability', professionalId],
    queryFn: () => availabilityService.getByProfessional(professionalId!),
    enabled: !!professionalId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateAvailability() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateAvailabilityInput) => availabilityService.create(input),
    onSuccess: (_data, input) => {
      queryClient.invalidateQueries({ queryKey: ['availability', input.professionalId] });
      queryClient.invalidateQueries({ queryKey: ['currentDbUser'] });
    },
  });
}

export function useBatchReplaceAvailability(professionalId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ slots, effectiveFrom }: { slots: SlotInput[]; effectiveFrom?: string }) =>
      availabilityService.batchReplace(professionalId, slots, effectiveFrom),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['availability', professionalId] });
      queryClient.invalidateQueries({ queryKey: ['currentDbUser'] });
    },
  });
}
